import 'reflect-metadata';
import { container } from 'tsyringe';
import { EventBus } from './eventBus/eventBus';
import { WebSocketManager } from './webSocketManager/webSocketManager';
/**
 * Commons infrastructure module dependency injection
 * All infrastructure module dependency injection is imported
 * @returns  void
 */
export const DependencyInjectionCommonsInfrastructure = () => {
    container.registerInstance('IEventBus', EventBus.getInstance());
    container.registerInstance('ISocketmanager', new WebSocketManager());
};
export default DependencyInjectionCommonsInfrastructure;
